import { API } from "./api";
import type {
    UpsPickUpRequest,
    UpsPickUpResponse,
    UpsRateRequest, UpsRateResponse,
    UpsShipRequest, UpsShipResponse,
    // UpsTrackResponse
} from "../types/upsTypes";

// ----- RATING -----
export async function cotarUPS(payload: UpsRateRequest) {
    const { data } = await API.post<UpsRateResponse>("/api/ups/rating", payload);
    return data;
}

// ----- SHIPPING -----
export async function emitirUPS(payload: UpsShipRequest) {
    const { data } = await API.post<UpsShipResponse>("/api/ups/shipping", payload);
    return data;
}

// ----- TRACKING -----
// services/ups.ts
export async function rastrearUPS(tn: string) {
    return (await API.get(`/api/ups/tracking/${encodeURIComponent(tn)}`)).data;
}

export function agendarPickupCotacao(id: string, payload: {
    pickupDate: string;      // "2025-02-11"
    readyTime: string;       // "0900" ou "09:00"
    closeTime: string;       // "1700" ou "17:00"
    serviceCode?: string;    // opcional
}) {
    return API.post(`/api/cotacoes/${id}/pickup`, payload);
}

